import NumberFormat, { NumberFormatValues } from 'react-number-format';
import {
  TextFormField,
  TextFormFieldProps
} from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/TextFormField';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AmountFormFieldProps extends TextFormFieldProps {
  defaultValue?: number;
  onValueChange?: (value: number | undefined) => void;
}

interface FormatType {
  prefix: string;
  suffix: string;
  thousandSeparator: string;
  decimalSeparator: string;
}

const formats: Record<string, FormatType> = {
  en: { prefix: '$ ', suffix: '', thousandSeparator: ',', decimalSeparator: '.' },
  fr: { prefix: '', suffix: ' $', thousandSeparator: ' ', decimalSeparator: ',' }
};

export const AmountFormField = ({ ...props }: AmountFormFieldProps) => {
  const { i18n } = useTranslation('HbtArrearsInquiryPage');
  const format = formats[i18n.language];

  return (
    <NumberFormat
      prefix={format.prefix}
      suffix={format.suffix}
      thousandSeparator={format.thousandSeparator}
      decimalSeparator={format.decimalSeparator}
      decimalScale={2}
      fixedDecimalScale={true}
      allowLeadingZeros={false}
      value={props.defaultValue ?? ''}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        if (!Number.isNaN(Number(e.target.value))) {
          props.onChange?.(e);
        }
      }}
      onValueChange={(values: NumberFormatValues) => props.onValueChange?.(values.floatValue)}
      customInput={TextFormField}
      name={props.name}
      disabled={props.disabled}
      inputRef={props.inputRef}
      inputProps={props.inputProps}
      error={props.error}
      helperText={props.helperText}
      showClearButton={props.showClearButton}
      onClear={props.onClear}
    />
  );
};
